import { state } from "./state";
import { mutations } from "./mutations";
import { actions } from "./actions";

export const levyCollectionOverrides = {
  state,
  mutations,
  actions
};
